import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Nav, Search, SignOut, Cancel } from 'theme/icon';
import ListStockSearch from 'components/ListStockSearch';
import logo1 from 'assets/images/ebiTrade_white.png';
import 'assets/css/navbar.css';
import Notification from './Notification';
import { CoinSummary } from './Navbar/components';

const Navbar = (props) => {
  const { search_text } = props;
  const [openTogle, setOpenTogle] = useState(false);

  const handleClick = () => {
    setOpenTogle((prev) => !prev);
  };

  const mobileDrawer = openTogle && (
    <div className="navbar-mobile-drawer">
      <ul className="list">
        <li className="list-item">
          <div className="list-item-content navbar-mobile-action">
            <Notification />
            <span>Notifications</span>
          </div>
        </li>
        <li className="list-item">
          <div className="list-item-content navbar-mobile-action">
            <CoinSummary />
            <span>Coins</span>
          </div>
        </li>
        <li className="list-item">
          <a className="list-item-content navbar-mobile-action" href="/login">
            <SignOut size={22} />
            <span>Exit</span>
          </a>
        </li>
      </ul>
    </div>
  );

  return (
    <nav className="navbar-custom fixed-top">
      <div className="navbar-inner">
        <RouterLink to="/" className="navbar-brand">
          <img alt="Logo" src={logo1} className="navbar-logo-img" />
        </RouterLink>

        <div className="navbar-search" role="search">
          <input
            className="nav-search-input"
            type="text"
            name="stock-symbol-query"
            placeholder="Search stocks, symbols or news..."
            aria-label="Search"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
            data-lpignore="true"
            data-1p-ignore="true"
            value={search_text}
            onChange={props.Search}
          />
          {search_text.length > 0 && (
            <span
              className="nav-search-clear"
              aria-label="Clear search"
              onClick={props.onClickClear}
            >
              <Cancel />
            </span>
          )}
          <button className="nav-search-btn" type="button" aria-label="Submit search">
            <Search />
          </button>
          {search_text.length > 0 && (
            <ListStockSearch
              list={props.list}
              loading={props.loading}
              onClickStock={props.onClickStock}
            />
          )}
        </div>

        <div className="navbar-end">
          <ul className="navbar-icons navbar-icons--desktop">
            <li className="nav-item">
              <Notification />
            </li>
            <li className="nav-item">
              <CoinSummary />
            </li>
            <li className="nav-item">
              <a className="icon-button" href="/login" aria-label="Sign out">
                <SignOut size={22} />
              </a>
            </li>
          </ul>

          <button
            className="navbar-toggler"
            type="button"
            aria-expanded={openTogle}
            aria-label="Toggle navigation"
            onClick={handleClick}
          >
            <Nav />
          </button>
        </div>
      </div>

      {mobileDrawer}
    </nav>
  );
};

Navbar.propTypes = {
  className: PropTypes.string,
};

export default Navbar;
